import { render, staticRenderFns } from "./AddOrderType.vue?vue&type=template&id=e2e344a0&scoped=true&"
import script from "./AddOrderType.vue?vue&type=script&lang=js&"
export * from "./AddOrderType.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderType.vue?vue&type=style&index=0&id=e2e344a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e344a0",
  null
  
)

export default component.exports